import React from "react";

import ReactDOM from "react-dom";
import App from "./app";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("app")
);
